import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';

interface ScreenoutScreenProps {
  title?: string;
  message?: string;
  returnUrl?: string;
  autoRedirect?: boolean;
  redirectDelay?: number;
}

export function ScreenoutScreen({
  title = 'Thank you for your interest',
  message = "Unfortunately, you don't qualify for this survey at this time.",
  returnUrl,
  autoRedirect = true,
  redirectDelay = 3,
}: ScreenoutScreenProps) {
  const [countdown, setCountdown] = useState(redirectDelay);

  useEffect(() => {
    if (!returnUrl || !autoRedirect) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = returnUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [returnUrl, autoRedirect]);

  const handleContinue = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md text-center">
        {/* Info icon */}
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
          <svg
            className="h-8 w-8 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="mb-2 text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="mb-6 text-gray-600">{message}</p>

        {returnUrl && (
          <>
            {autoRedirect && countdown > 0 ? (
              <p className="text-sm text-gray-500">
                Redirecting in {countdown} seconds...
              </p>
            ) : (
              <Button onClick={handleContinue} variant="primary">
                Continue
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
